/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  dataGrid: Item<'DataGrid'>;
  idNumberColumn: Item<'NumberColumn'>;
  imageColumn: Item<'ImageColumn'>;
} = {
  root: {
    children: ['testAliasLocalDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: { all: 0 },
      windowTitle: { type: 'text', value: 'Image Column Example' },
    },
    type: 'Page',
  },

  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },

  flexItem: {
    children: ['testAliasDataStoreReference'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },

  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: `[
  { "id": 1, "imageUrl": "https://picsum.photos/id/1011/100/100" },
  { "id": 2, "imageUrl": "https://picsum.photos/id/1025/100/100" },
  { "id": 3, "imageUrl": "https://picsum.photos/id/1005/100/100" },
  { "id": 4, "imageUrl": "https://picsum.photos/id/1012/100/100" },
  { "id": 5, "imageUrl": "https://picsum.photos/id/1003/100/100" }
]`,
    },
    type: 'LocalDataStore',
  },

  testAliasDataStoreReference: {
    children: ['dataGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'flexItem',
    props: { alias: 'testAlias' },
    type: 'DataStoreReference',
  },

  dataGrid: {
    children: ['idNumberColumn', 'imageColumn'],
    itemId: 'dataGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      rowHeight: 68,
      expandLastColumn: false,
      showBorder: true,
      updatable: { type: 'boolean', value: false },
      insertable: { type: 'boolean', value: false },
    },
    type: 'DataGrid',
  },

  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'dataGrid',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'ID' },
      viewAttribute: 'id',
      width: 60,
    },
    type: 'NumberColumn',
  },

  imageColumn: {
    children: [],
    itemId: 'imageColumn',
    parent: 'dataGrid',
    props: {
      alignment: 'center',
      label: { type: 'text', value: 'Profile Picture' },
      viewAttribute: 'imageUrl',
      width: 150,
    },
    type: 'ImageColumn',
  },
};

export const helpRenders: ComponentSample<'ImageColumn'>[] = [
  {
    title: 'Image Column Example',
    page,
    exampleId: 'eg-01GK8QWM9KTAE6TN0ME1F8WQIMAGE',
    clearParentChildren: false,
    height: 420,
    visibleProps: [
      'label',
      'alignment',
      'viewAttribute',
      'width',
      'pinLeft',
      'pinRight',
      'sortable',
      'filterable',
    ],
    item: {
      children: [],
      itemId: 'imageColumn',
      parent: 'dataGrid',
      type: 'ImageColumn',
      props: {
        alignment: 'center',
        label: { type: 'text', value: 'Profile Picture' },
        viewAttribute: 'imageUrl',
        width: 150,
      },
    },
  },
];
